import styled from 'styled-components';

import { CuiTheme } from '@crehana/ui';

import { ResponsiveSize } from './types';

export const StyledH2 = styled.h2`
  max-width: 550px;
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    max-width: 750px;
  }
`;

export const StyledSection = styled.section`
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
    border-top-left-radius: 80px;
    border-top-right-radius: 80px;
  }

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    border-top-left-radius: 135px;
    border-top-right-radius: 135px;
    min-height: 700px;
  }
`;

export const StyledImage = styled.div`
  width: 70%;
  height: 100%;
  margin: auto;
`;

export const BottomOpacity = styled.div`
  pointer-events: none;
  height: 70%;
  background: linear-gradient(0deg, #f7f8fa 15%, rgba(247, 248, 250, 0) 70%);
`;

export const CompanyCircle = styled.div<{
  size: ResponsiveSize;
  margin?: ResponsiveSize;
}>`
  transition: 0.2s;
  width: ${({ size }) => size.xs}px;
  height: ${({ size }) => size.xs}px;
  margin-right: ${({ margin }) => margin?.xs || 0}px;

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
    width: ${({ size }) => size.sm}px;
    height: ${({ size }) => size.sm}px;
    margin-right: ${({ margin }) => margin?.sm || 0}px;
  }

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    width: ${({ size }) => size.md}px;
    height: ${({ size }) => size.md}px;
    margin-right: ${({ margin }) => margin?.md || 0}px;
  }

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    width: ${({ size }) => size.lg}px;
    height: ${({ size }) => size.lg}px;
    margin-right: ${({ margin }) => margin?.lg || 0}px;
  }

  :hover {
    transition: 0.2s;
    transform: scale(1.1);
  }
`;
